import {
  DeviceUnauthorizedDialog,
  DevicesDialog
} from "../chunk-EVHOV63B.js";
import "../chunk-O3EQCY62.js";
import "../chunk-NVQHPHNR.js";
import {
  logoutHandlerFactory
} from "../chunk-W4TWOJ4Y.js";
import {
  withVersion
} from "../chunk-UEDPR2CR.js";
import "../chunk-KVCLZREV.js";
import "../chunk-2CSC3FHL.js";

// lib/user/userInfo.tsx
import styled from "@emotion/styled";
import { logResults } from "@lune/common/logger";
import { Theme as Theme2 } from "@lune/theme/context";
import { PersonOffOutlined as NobodyIcon } from "@mui/icons-material";
import { Backdrop, CircularProgress, Avatar as MuiAvatar } from "@mui/material";
import { useContext as useContext2, useEffect as useEffect2, useState as useState2 } from "react";

// lib/user/menu.tsx
import { Theme } from "@lune/theme/context";
import {
  DevicesOutlined as DevicesIcon,
  Logout as LogoutIcon,
  Security as SecurityIcon
} from "@mui/icons-material";
import {
  Divider,
  ListItemIcon,
  ListSubheader,
  Menu as MuiMenu,
  MenuItem
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var paperProps = {
  elevation: 0,
  sx: {
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    mt: 1.5,
    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1
    },
    "&:before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: "background.paper",
      transform: "translateY(-50%) rotate(45deg)",
      zIndex: 0
    }
  }
};
var Menu = ({
  target,
  onLogoutClick,
  onClose,
  onSecurityClick,
  onDevicesClick
}) => {
  const [anchorEl, setAnchorEl] = useState();
  const open = Boolean(anchorEl);
  const themeContext = useContext(Theme);
  const handleClose = () => {
    setAnchorEl(null);
    onClose();
  };
  useEffect(() => {
    setAnchorEl(target);
  }, [target]);
  return /* @__PURE__ */ jsxs(
    MuiMenu,
    {
      anchorEl,
      id: "account-menu",
      open,
      onClose: handleClose,
      onClick: handleClose,
      PaperProps: paperProps,
      transformOrigin: { horizontal: "right", vertical: "top" },
      anchorOrigin: { horizontal: "right", vertical: "bottom" },
      children: [
        onSecurityClick != null && [
          /* @__PURE__ */ jsx(Divider, {}, "security-divider"),
          /* @__PURE__ */ jsx(
            ListSubheader,
            {
              sx: {
                lineHeight: "32px",
                fontSize: "0.7rem",
                letterSpacing: "0.08em",
                textTransform: "uppercase"
              },
              children: "Settings"
            },
            "security-header"
          ),
          /* @__PURE__ */ jsxs(MenuItem, { onClick: onSecurityClick, children: [
            /* @__PURE__ */ jsx(ListItemIcon, { children: /* @__PURE__ */ jsx(SecurityIcon, { fontSize: "small" }) }),
            "Security"
          ] }, "security")
        ],
        onDevicesClick != null && /* @__PURE__ */ jsxs(MenuItem, { onClick: onDevicesClick, children: [
          /* @__PURE__ */ jsx(ListItemIcon, { children: /* @__PURE__ */ jsx(DevicesIcon, { fontSize: "small" }) }),
          "Devices"
        ] }, "devices"),
        /* @__PURE__ */ jsx(Divider, {}),
        /* @__PURE__ */ jsxs(
          MenuItem,
          {
            onClick: themeContext.toggle,
            onContextMenu: themeContext.reset,
            children: [
              /* @__PURE__ */ jsx(ListItemIcon, { children: themeContext.icon }),
              themeContext.text
            ]
          }
        ),
        /* @__PURE__ */ jsxs(MenuItem, { onClick: onLogoutClick, children: [
          /* @__PURE__ */ jsx(ListItemIcon, { children: /* @__PURE__ */ jsx(LogoutIcon, {}) }),
          "Logout"
        ] })
      ]
    }
  );
};

// lib/user/userInfo.tsx
import { Fragment, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var Avatar = styled(MuiAvatar)(() => {
  const theme = useContext2(Theme2);
  return theme.mode === "dark" ? { filter: "grayscale(1)" } : {};
});
var UserInfo = ({
  version,
  loginUrl,
  rootUrl,
  securityUrl
}) => {
  const [userInfo, setUserInfo] = useState2();
  const [processing, setProcessing] = useState2(false);
  const [anchorEl, setAnchorEl] = useState2(null);
  const [openMenu, setOpenMenu] = useState2(false);
  const [openDevices, setOpenDevices] = useState2(false);
  const handlePopoverOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  useEffect2(() => {
    void withVersion(version, loginUrl, rootUrl).then(async (auth) => {
      await auth.whoamiNotEnsured().then(logResults("userInfo.whoami")).then(setUserInfo).catch(() => {
      });
    });
  }, [loginUrl, rootUrl, version]);
  return /* @__PURE__ */ jsxs2(Fragment, { children: [
    userInfo?.avatar !== void 0 ? /* @__PURE__ */ jsxs2("div", { onMouseEnter: handlePopoverOpen, onMouseLeave: handlePopoverClose, children: [
      /* @__PURE__ */ jsx2(
        Avatar,
        {
          src: userInfo.avatar.toString(),
          onClick: () => {
            setOpenMenu(true);
          }
        }
      ),
      /* @__PURE__ */ jsx2(
        Menu,
        {
          target: openMenu ? anchorEl : null,
          onClose: () => {
            setOpenMenu(false);
          },
          onLogoutClick: logoutHandlerFactory(
            version,
            loginUrl,
            rootUrl,
            () => {
              setProcessing(true);
            }
          ),
          onSecurityClick: securityUrl != null ? () => {
            window.location.assign(securityUrl.security.url.toString());
          } : void 0,
          onDevicesClick: () => {
            setOpenDevices(true);
          }
        }
      ),
      /* @__PURE__ */ jsx2(Backdrop, { open: processing, children: /* @__PURE__ */ jsx2(CircularProgress, { color: "inherit" }) }),
      /* @__PURE__ */ jsx2(
        DevicesDialog,
        {
          open: openDevices,
          onClose: () => {
            setOpenDevices(false);
          },
          version,
          rootUrl,
          isAdmin: userInfo.admin ?? false
        }
      )
    ] }) : /* @__PURE__ */ jsx2(Avatar, { children: /* @__PURE__ */ jsx2(NobodyIcon, {}) }),
    /* @__PURE__ */ jsx2(DeviceUnauthorizedDialog, {})
  ] });
};
export {
  UserInfo
};
